// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"d771ed12","158":"15cf6f38","168":"79d47721","396":"e0240847","420":"3d0f9519","655":"493e975e"}[chunkId] + ".chunk.css";
};